import React, { useRef, useEffect, useState } from "react";
import LOgicalREs from "../../../assets/E&L.png"
import two from "../../../assets/2.png"
import three from "../../../assets/3.png";
import four from "../../../assets/4.png";
import five from "../../../assets/5.png";
import six from "../../../assets/6.png";
import seven from "../../../assets/7.png";
import eight from "../../../assets/8.png";


const courses = [
  {
    id: 1,
    title: "Logical Reasoning",
    // description:
    //   "Explore how great ideas become thriving ventures and learn the skills to lead with confidence. Master strategic planning, effective communication, and teamwork to shape the future.",
    image: LOgicalREs,
    // image2: "https://dbqa318yoj3nn.cloudfront.net/image1.svg",
  },
  {
    id: 2,
    title: "Leadership & Teamwork",
    // description:
    //   "Discover how AI learns, thinks, and transforms industries worldwide. From chatbots to self-driving cars, gain the skills to innovate and build smart solutions.",
    image: two,
    // image2: "https://dbqa318yoj3nn.cloudfront.net/image2.png",
  },
  {
    id: 3,
    title: "Project Management & Presentation",
    // description:
    //   "Learn budgeting, saving, investing, and debt management to take charge of your finances. Acquire real-world money skills that empower you to achieve your goals.",
    image: three,
    // image2: "https://dbqa318yoj3nn.cloudfront.net/image3.png",
  },
  {
    id: 4,
    title: "Communication Skills",
    // description:
    //   "Explore how robots move, sense, and interact, from mechanical design to programming. Discover real-world applications, fueling your passion for innovation and problem-solving.",
    image: four,
    // image2:  "https://dbqa318yoj3nn.cloudfront.net/image4.png",
  },
  {
    id: 5,
    title: "Data Literacy",
    // description:
    //   "Sharpen your analytical mindset to tackle challenges with clarity and creativity. Use proven strategies, dynamic exercises, and logical reasoning to solve problems like a pro.",
    image: five,
    // image2: "https://dbqa318yoj3nn.cloudfront.net/image5.png",
  },
  {
    id: 6,
    title: "Business Writing",
    // description:
    //   "Discover how ethical choices and active citizenship can shape communities and the world. Explore human rights, sustainability, and leadership to drive meaningful change.",
    image: six,
    // image2: "https://dbqa318yoj3nn.cloudfront.net/image6.png",
  },
  {
    id: 7,
    title: "Emotional Intelligence",
    // description:
    //   "Unlock your creative potential and turn bold ideas into real solutions. Embrace imaginative thinking, experiment fearlessly, and innovate for a brighter future.",
    image: seven,
    // image2: "https://dbqa318yoj3nn.cloudfront.net/image7.png",
  },
  {
    id: 8,
    title: "Networking with Global Mentors",
    // description:
    //   "Learn programming fundamentals to build apps, websites, or games from scratch. Sharpen your logic, open career doors, and thrive in our tech-driven world.",
    image: eight,
    // image2: "https://dbqa318yoj3nn.cloudfront.net/image8.png",
  },
  
];

const backgroundColors = [
  "#FFD0F9",
  "#FFCFC1",
  "#B1C5FF",
  "#FFF7C5",
  "#CBFF9E",
  "#F8CFFF",
  "#FFF5B1",
  "#FFD6C4",
];
const titleColors = [
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
];

const descriptionColors = [
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
  "#000",
];

export default function Slider() {
  const containerRef = useRef(null);

  const scrollLeft = () => {
    const isMobile = window.innerWidth <= 768;
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: isMobile ? -320 : -700,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    const isMobile = window.innerWidth <= 768;
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: isMobile ? 320 : 700,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center", // ✅ Center vertically
          minHeight: "50vh",       // ✅ Full viewport height
          padding: "40px 0",        // ✅ Top/bottom padding
          margin: "0 auto",         // ✅ Center horizontally
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <div
          ref={containerRef}
          style={{
            display: "flex",
            overflowX: "auto",
            width: "100%",
            maxWidth: "90vw", // ✅ Prevents overflow and centers better
            scrollBehavior: "smooth",
            paddingBottom: "20px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {courses.map((course, index) => (
            <div
              key={course.id}
              style={{
                flex: "0 0 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "310px",
                height: "300px",
                padding: "20px",
                borderRadius: "10px",
                backgroundColor: backgroundColors[index % backgroundColors.length],
                justifyContent: "center",
                marginRight: "30px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "8px 20px 10px rgba(0, 0, 0, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "";
              }}
            >
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: titleColors[index % titleColors.length],
                  textAlign: "center",
                  fontFamily: "Montserrat",
                }}
              >
                {course.title}
              </h2>
              <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.2",
                    marginTop: "10px",
                    padding: "10px",
                    fontWeight: "medium",
                    color: descriptionColors[index % descriptionColors.length],
                    fontFamily: "Poppins",
                  }}
                >
                  {course.description}
                </p>
                <div
                  style={{
                    position: "relative",
                    width: "530px",
                    height: "auto",
                  }}
                >
                  <img
                    src={course.image}
                    alt={course.title}
                    style={{ width: "200px", height: "200px" }}
                  />
                  {/* <img
                    src={course.image2}
                    alt="Overlay"
                    style={{
                      position: "absolute",
                      top: "8px",
                      left: "0",
                      width: "110px",
                      height: "auto",
                    }}
                  /> */}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
            gap: "20px",
          }}
        >
          <button
            onClick={scrollLeft}
            style={{
              padding: "10px 20px",
              fontSize: "30px",
              color: "#fff",
              backgroundColor: "rgb(15, 119, 230)",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = "rgb(250, 124, 7)")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "rgb(15, 119, 230)")
            }
          >
            &larr;
          </button>
          <button
            onClick={scrollRight}
            style={{
              padding: "10px 20px",
              fontSize: "30px",
              color: "#fff",
              backgroundColor: "rgb(15, 119, 230)",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = "rgb(250, 124, 7)")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "rgb(15, 119, 230)")
            }
          >
            &rarr;
          </button>
        </div>
      </div>

      {/* ✅ Optional: Hide scrollbar for WebKit */}
      <style>
        {`
          ::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
    </>
  );
}